import { createAction } from 'redux-actions';
import {
	GET_OUTING_PUNCH_SETTING_CALL,
	GET_OUTING_PUNCH_SETTING_DONE,
	GET_OUTING_PUNCH_SETTING_FAIL,
	GET_OUTING_PUNCH_CALL,
	GET_OUTING_PUNCH_DONE,
	GET_OUTING_PUNCH_FAIL,
	POST_OUTING_PUNCH_CALL,
	POST_OUTING_PUNCH_DONE,
	POST_OUTING_PUNCH_FAIL,
	DELETE_OUTING_PUNCH_CALL,
	DELETE_OUTING_PUNCH_DONE,
	DELETE_OUTING_PUNCH_FAIL,
	GET_OUTING_PUNCH_ATTACHMENT_CALL,
	GET_OUTING_PUNCH_ATTACHMENT_DONE,
	GET_OUTING_PUNCH_ATTACHMENT_FAIL,
	DELETE_OUTING_PUNCH_ATTACHMENTS_CALL,
	DELETE_OUTING_PUNCH_ATTACHMENTS_DONE,
	DELETE_OUTING_PUNCH_ATTACHMENTS_FAIL,
} from '@src/store/types/outingPunch';

export const getOutingPunchSettingCall = createAction(GET_OUTING_PUNCH_SETTING_CALL);
export const getOutingPunchSettingDone = createAction(GET_OUTING_PUNCH_SETTING_DONE);
export const getOutingPunchSettingFail = createAction(GET_OUTING_PUNCH_SETTING_FAIL);

export const getOutingPunchCall = createAction(GET_OUTING_PUNCH_CALL);
export const getOutingPunchDone = createAction(GET_OUTING_PUNCH_DONE);
export const getOutingPunchFail = createAction(GET_OUTING_PUNCH_FAIL);

export const postOutingPunchCall = createAction(POST_OUTING_PUNCH_CALL);
export const postOutingPunchDone = createAction(POST_OUTING_PUNCH_DONE);
export const postOutingPunchFail = createAction(POST_OUTING_PUNCH_FAIL);

export const deleteOutingPunchCall = createAction(DELETE_OUTING_PUNCH_CALL);
export const deleteOutingPunchDone = createAction(DELETE_OUTING_PUNCH_DONE);
export const deleteOutingPunchFail = createAction(DELETE_OUTING_PUNCH_FAIL);

export const getOutingPunchAttachmentCall = createAction(GET_OUTING_PUNCH_ATTACHMENT_CALL);
export const getOutingPunchAttachmentDone = createAction(GET_OUTING_PUNCH_ATTACHMENT_DONE);
export const getOutingPunchAttachmentFail = createAction(GET_OUTING_PUNCH_ATTACHMENT_FAIL);

export const deleteOutingPunchAttachmentsCall = createAction(DELETE_OUTING_PUNCH_ATTACHMENTS_CALL);
export const deleteOutingPunchAttachmentsDone = createAction(DELETE_OUTING_PUNCH_ATTACHMENTS_DONE);
export const deleteOutingPunchAttachmentsFail = createAction(DELETE_OUTING_PUNCH_ATTACHMENTS_FAIL);
